import { mapActions, mapMutations, mapGetters } from 'vuex';

export default {
    methods: {
        ...mapActions({
            updateProperty: 'properties/updateProperty',
            saveProperty: 'properties/saveProperty',
            deleteImage: 'properties/deleteImage',
            uploadImages: 'properties/uploadImages',
            addRenting: 'properties/addRenting',
            deleteRenting: 'properties/deleteRenting',
            addOwner: 'properties/addOwner',
            removeOwner: 'properties/removeOwner',
        }),

        ...mapMutations({
            selectProperty: 'properties/SELECT_PROPERTY'
        })
    },

    computed: {
        ...mapGetters({
            properties: 'properties/properties',
            allProperties: 'properties/allProperties',
            selectedProperty: 'properties/selectedProperty'
        })
    }
}